<template>
    <div>
        <layout-headers title="menuItemsPageTitle" text="menuItemsPageSubtitle" :redirectButtons="redirectButtons" />
        <el-card>
            <el-table :data="tableData" :empty-text="emptyText">
                <el-table-column
                    prop="position"
                    :label="$t('menuItemsPosition')">
                </el-table-column>
                <el-table-column
                    prop="description"
                    :label="$t('menuItemsDescription')">
                </el-table-column>
                <el-table-column
                    prop="actions"
                    fixed="right"
                    width="100"
                    :label="$t('tableActions')">
                    <template slot-scope="scope">
                        <el-button  icon="el-icon-edit" class="table-button"
                                @click="edit('MenuItemsEdit', scope.row, 'menuItem')"/>
                        <el-button  icon="el-icon-delete" class="table-button"
                                @click="showModal(scope.row.id)"/>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <modal :config="modalConfig" @closeModal="deleteItem" />

    </div>
</template>

<script>
import LayoutHeaders from '@/components/LayoutPart/LayoutHeaders'
import { mapGetters } from 'vuex'
import {showModal, closeModal} from "../Modal/ModalHelpers"
import {edit} from '../../helpers/helpers.js'

export default {
    components: {
        LayoutHeaders
    },
    data () {
        return {
            emptyText: 'Loading...',
            modalConfig: { show: false },
            tableData: [],
            redirectButtons: [
                {
                    path: 'MenuItemsCreate',
                    param: {
                        isEdit: false,
                        menuItem: {
                            description: '',
                            menu: [],
                            position: ''
                        }
                    },
                    text: 'menuItemsButton'
                }
            ],
        }
    },
    computed: {
        ...mapGetters({
            menuItems: 'getMenuItems'
        })
    },
    created () {
        console.log("vnf")
        this.initTable()
    },
    methods: {
        showModal, closeModal,
        edit,
        async initTable () {
            await this.$store.dispatch('fetchMenuItems')
            await this.$store.dispatch('fetchContents')
            this.tableData = this.menuItems
            
            setTimeout(() => { this.emptyText = 'No results' }, 1500)
        },
        deleteItem () {
            this.modalConfig.show = false;
            this.$store.dispatch('deleteMenu', this.id)
            .then((res) => {
                if (res)
                    this.node = ''
            })
        }
    }
}
</script>

<style scoped>
/* @import url("//unpkg.com/element-ui@2.4.8/lib/theme-chalk/index.css"); */

.table-button {
        width: 30px !important; 
        height: 30px !important; 
        padding: 0 !important; 
        margin: 0 !important;
        background: transparent !important;
        color: darkgrey;
        font-size: 20px;
        font-weight: 800;
        border: none;
    }

    .table-button:hover {
        color: #409EFF !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/MenuItems/MenuItems.vue